import { api } from "./api";

/**
 * Quote requests from the contact form.
 *
 * The only write the public site makes. Unlike the read services there is no
 * fallback to bundled data — if the request fails the customer must be told,
 * not quietly reassured while their enquiry goes nowhere.
 */
export const enquiryService = {
  submit: async (payload) => {
    try {
      const response = await api.post("/enquiries", payload);
      return { ok: true, data: response.data };
    } catch (error) {
      const body = error?.response?.data?.error;

      return {
        ok: false,
        message:
          body?.message ||
          (error?.response?.status === 429
            ? "Too many requests from this connection. Please try again shortly, or message us on WhatsApp."
            : "We could not send your request just now. Please try again, or message us on WhatsApp."),
        fields: body?.details && typeof body.details === "object" ? body.details : null,
      };
    }
  },
};
